import storiesPhone from "../assets/Stories.png";
import cameraAccent from "../assets/camera.png";
import heartPulse from "../assets/HeartPulse.png";

const StoriesSection = () => {
  return (
    <section className="bg-white overflow-hidden">
      <div className="max-w-[1520px] mx-auto px-4 md:px-6 lg:px-8 py-14 md:py-20 lg:py-[100px] xl:py-28 2xl:py-32">
        <div className="relative overflow-hidden lg:min-h-[620px] xl:min-h-[680px]">
          <div className="hidden lg:block absolute inset-y-0 right-0 w-1/2 bg-[#F1F4EF]" />

          <div className="relative lg:grid lg:grid-cols-2 lg:min-h-[620px] xl:min-h-[680px]">
            {/* Left half - image fills height, right edge meets split */}
            <div className="bg-[#CCF0C0] py-10 md:py-14 lg:py-0 lg:h-full flex items-center lg:items-stretch justify-end overflow-hidden relative">
              <img
                src={storiesPhone}
                alt="Stories feature preview"
                className="w-full max-w-[360px] sm:max-w-[420px] md:max-w-[470px] h-auto object-contain lg:hidden"
              />
              <img
                src={storiesPhone}
                alt="Stories feature preview"
                className="hidden lg:block h-full min-h-[620px] xl:min-h-[680px] w-auto object-contain object-right"
              />
            </div>

            {/* Mobile: HeartPulse at the boundary between green and gray */}
            <div className="lg:hidden relative z-10 -mt-[28px] -mb-[28px] px-4 py-2 flex justify-center bg-[linear-gradient(to_bottom,#CCF0C0_0%,#CCF0C0_50%,#F1F4EF_50%,#F1F4EF_100%)]">
              <img
                src={heartPulse}
                alt=""
                aria-hidden="true"
                className="w-[130px] sm:w-[148px] h-auto object-contain"
              />
            </div>

            <div className="bg-[#F1F4EF] lg:bg-transparent py-10 md:py-14 lg:py-0 px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-20 relative flex flex-col justify-center">
              <img
                src={cameraAccent}
                alt=""
                aria-hidden="true"
                className="hidden lg:block absolute top-[88px] left-0 -translate-x-1/2 w-[118px] xl:w-[138px] 2xl:w-[300px] h-auto object-contain"
              />

              <div className="max-w-[611px] lg:pt-0">
                <h3 className="text-[38px] leading-[46px] sm:text-[44px] sm:leading-[54px] lg:text-[65px] lg:leading-[80px] font-bold text-[#0B0D0B]">
                  Stories
                </h3>
                <p className="mt-4 lg:mt-5 text-lg leading-7 sm:text-xl sm:leading-8 lg:text-[28px] lg:leading-[38px] text-[#0B0D0B]">
                  Share moments without pressure.
                </p>
              </div>

              {/* Desktop: HeartPulse positioned absolutely */}
              <img
                src={heartPulse}
                alt=""
                aria-hidden="true"
                className="hidden lg:block absolute left-0 -translate-x-1/2 bottom-[110px] w-[80px] xl:w-[100px] 2xl:w-[120px] h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoriesSection;
